import {
  COURSE_RESOURCE_DATA,
  COURSE_TITLES,
} from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'

type Props = {
  courseName: CourseNameType
  title?: string
}

const RelatedResources = ({ courseName, title }: Props) => {
  const coursesResources = COURSE_RESOURCE_DATA[courseName]
  return (
    <div className="mt-20 mb-8 flex flex-col text-grey container justify-center mx-auto">
      <h2 className="text-2xl font-700 mb-8 leading-tight">
        {title ? title : `Resources related to ${COURSE_TITLES[courseName]}`}
      </h2>
      <div className="grid lg:grid-cols-2 gap-6">
        {coursesResources.map((resource, i) => (
          <section key={i} className="bg-grey-300 p-5">
            <h3 className="font-600 text-lg mb-2">{resource.title}</h3>
            <p>{resource.description}</p>
            <a
              href={resource.link}
              target="_blank"
              rel="noreferrer"
              className="underline font-600 mt-6 block"
            >
              Read more
            </a>
          </section>
        ))}
      </div>
    </div>
  )
}

export default RelatedResources
